import Glide from '@glidejs/glide';

const paintingsSlider = document.querySelector('.paintings-slider');
paintingsSlider && new Glide(paintingsSlider, {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  gap: 30,
  autoplay: 3000,
  animationDuration: 1000
}).mount();

const timelineSliders = document.querySelectorAll('.timeline-slider');
const timelineSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000
};

Object.values(timelineSliders).map(slider => {
  new Glide(slider, timelineSliderOptions).mount();
});

const contentSliders = document.querySelectorAll('.content-slider');
const contentSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000
};

Object.values(contentSliders).map(slider => {
  new Glide(slider, contentSliderOptions).mount();
});

const eventSliders = document.querySelectorAll('.event-slider');
const eventSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000
};

Object.values(eventSliders).map(slider => {
  new Glide(slider, eventSliderOptions).mount();
});

const headerSliders = document.querySelectorAll('.header-slider');
const headerSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 4500,
  gap: 0,
  rewindDuration: 0,
  animationDuration: 0,
  hoverpause: false,
  keyboard: false,
  swipeThreshold: false,
  dragThreshold: false
};

Object.values(headerSliders).map(slider => {
  const glide = new Glide(slider, headerSliderOptions);
  glide.on('run.after', function () {
    const otherSlides = slider.querySelectorAll('.glide__slide:not(.glide__slide--active) img');
    for (const slide of otherSlides) {
      setTimeout(() => {
        // this resets the css animation on the other slides
        slide.style.animation = 'none';
        slide.offsetHeight;
        slide.style.animation = '';
      }, 2500);
    }
  });
  glide.mount();
});
